import { useMemo } from 'react';
import { useExternalConnectionsCalendarsQueries } from 'shared/hooks/queries/use-external-connections-calendars-queries';

import { useExternalCalendarConnections } from './use-external-calendar-connections';

export const useExternalCalendarConnectionsWithCalendars = () => {
  const connections = useExternalCalendarConnections();
  const connectionIds = useMemo(
    () => connections.map(({ id }) => id),
    [connections],
  );
  const { calendars, isPending } =
    useExternalConnectionsCalendarsQueries(connectionIds);

  return { connections, calendars, isPending };
};
